<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!request">
      <span class="loader"></span>
    </span>
    <request-form
      v-if="request"
      :loading="loading"
      :requestData="request"
      :formErrors="formErrors"
      @requestSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import RequestForm from "../partials/RequestForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import requestErrorMixin from "@/mixins/request-error-mixin";

export default {
  layout: "DashboardLayout",

  components: { RequestForm },

  mixins: [alertLeave, requestErrorMixin],

  props: {
    requestId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      request: null,
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        await this.$store.dispatch("requests/get", this.requestId);
        this.request = this.$store.getters["requests/request"];
        this.loading = false;
      } catch (error) {
        this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.loading = false;
      }
    },

    async handleSubmit(request) {
      this.loading = true;
      const requestData = cloneDeep(request);

      try {
        await this.$store.dispatch("requests/update", requestData);
        this.$notify({
          type: "success",
          timeout: 3000,
          message: this.$t("REQUESTS.REQUEST_UPDATED"),
        });
        const request = await this.$store.getters["requests/request"];
        this.$emit("onViewRequest", request, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
